/**
 * Staff authentication routes
 * 
 * Note: The main staff portal functionality is now handled by admin routes
 * (/admin/store/:slug/*) with federated staff authentication.
 * 
 * This file only contains auth-related routes that are used during the
 * handoff process from Lytning POS.
 * 
 * Authentication flow:
 * 1. Lytning generates a handoff JWT and POSTs to /v1/admin/auth/handoff
 * 2. Backend validates JWT, creates session, sets HttpOnly cookie
 * 3. Backend redirects to /admin/store/:slug/deliveries
 * 4. Admin routes use staffAuthGuard to validate the session cookie
 */

import type { RouteRecordRaw } from 'vue-router'

export const staffRoutes: RouteRecordRaw[] = [
  // Auth error page - shown when staff auth fails
  // Also used by /admin/auth/error via redirect in admin.routes.ts
  {
    path: '/staff/auth/error',
    name: 'StaffAuthError',
    component: () => import('@/views/staff/StaffAuthErrorView.vue'),
    meta: {
      title: 'Authentication Error',
      hideFromNav: true
    }
  }
]

export default staffRoutes
